const cookieValues = {
  addOn: {
    key: 'a',
    default: 0,
  },
  autoSuggest: {
    key: 'as',
    default: 1,
  },
  bingUserId: {
    key: 'cid',
    default: null,
  },
  customSettings: {
    key: 'cs',
    default: 0,
  },
  deviceType: {
    key: 'dt',
    default: 'pc',
  },
  adultFilter: {
    key: 'f',
    defualt: 'i',
  },
  firstRun: {
    key: 'fr',
    default: 0,
  },
  firstSearch: {
    key: 'fs',
    default: 1,
  },
  language: {
    key: 'l',
    default: null,
  },
  lastTree: {
    key: 'lt',
    default: 0,
  },
  marketApplied: {
    key: 'ma',
    default: 0,
  },
  bingMarketCode: {
    key: 'mc',
    default: 'en-us',
  },
  notifications: {
    key: 'nf',
    default: 1,
  },
  newTab: {
    key: 'nt',
    default: 0,
  },
  personalizedSearch: {
    key: 'ps',
    default: 0,
  },
  treeCount: {
    key: 't',
    default: 0,
  },
  typeTag: {
    key: 'tt',
    default: 'na',
  },
  temperatureUnit: {
    key: 'tu',
    default: 'auto',
  },
  windUnit: {
    key: 'wu',
    default: 'auto',
  },
};

const settingsScheme = {
  searchRegion: {
    cookieKey: 'bingMarketCode',
    type: 'string',
  },
  language: {
    cookieKey: 'language',
    type: 'string',
  },
  safeSearch: {
    cookieKey: 'adultFilter',
    type: 'string',
  },
  newTab: {
    cookieKey: 'newTab',
    type: 'toggle',
  },
  autoSuggest: {
    cookieKey: 'autoSuggest',
    type: 'toggle',
  },
  personalizedSearch: {
    cookieKey: 'personalizedSearch',
    type: 'toggle',
  },
  notifications: {
    cookieKey: 'notifications',
    type: 'toggle',
  },
};

exports.ecosiaUserScheme = settingsScheme;

exports.ecosiaUserToFormData = (user) => {
  const data = {};

  Object.keys(settingsScheme).forEach((key) => {
    const value = user.get(settingsScheme[key].cookieKey);
    switch (settingsScheme[key].type) {
      case 'toggle':
        data[key] = value === 1;
        break;
      case 'string':
      default:
        data[key] = value;
        break;
    }
  });

  return data;
};

exports.cookieName = require('../constants/cookies').MAIN;

exports.cookieValues = cookieValues;
